
import React from "react";

interface CheckoutGridProps {
  mainContent: React.ReactNode;
  sidebarContent: React.ReactNode;
}

const CheckoutGrid = ({ mainContent, sidebarContent }: CheckoutGridProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2">
        {mainContent}
      </div>
      <div className="lg:col-span-1">
        {sidebarContent}
      </div>
    </div>
  );
};

export default CheckoutGrid;
